export const BRANCHES = [
    {
      label: 'Main Regional Office',
      facilities: ['BJMPRO-III Main Office']
    },
    {
      label: 'Provincial Jail of Bataan',
      facilities: [
        'Bataan District Jail Male Dormitory',
        'Bataan District Jail Female Dormitory',
        'Balanga City Jail',
        'Mariveles Municipal Jail',
        'Dinalupihan Municipal Jail',
      ]
    },
    {
      label: 'Provincial Jail of Bulacan',
      facilities: [
        'Balagtas District Jail',
        'Baliwag City Jail',
        'Malolos City Jail',
        'Marilao Municipal Jail',
        'Meycauayan City Jail',
        'Plaridel Municipal Jail Male Dorm',
        'Plaridel Municipal Jail Female Dorm',
        'Pulilan Municipal Jail',
        'San Jose Del Monte City Jail Male Dorm',
        'San Jose Del Monte City Jail Female Dorm',
        'Sta. Maria Municipal Jail',
        'Bocaue Municipal Jail',
        'Guiguinto Municipal Jail',
      ]
    },
    {
      label: 'Provincial Jail of Nueva Ecija',
      facilities: [
        'Cabanatuan City District Jail Male Dormitory',
        'Cabanatuan City District Jail Female Dormitory',
        'Gapan City Jail',
        'Guimba District Jail',
        'San Jose City District Jail',
        'Talavera Municipal Jail',
      ]
    },
    {
      label: 'Provincial Jail of Pampanga',
      facilities: [
        'Angeles District Jail Male Dormitory',
        'Angeles District Jail Female Dormitory',
        'Arayat District Jail',
        'Guagua District Jail Male Dorm',
        'Guagua District Jail Female Dormitory',
        'San Fernando District Jail Male Dormitory',
        'San Fernando District Jail Female Dormitory',
      ]
    },
    {
      label: 'Provincial Jail of Tarlac',
      facilities: [
        'Paniqui Municipal Jail',
        'Tarlac City Jail Male Dorm',
        'Tarlac City Jail Female Dorm',
        'Camiling Municipal Jail',
      ]
    },
    {
      label: 'Provincial Jail of Zambales',
      facilities: [
        'Olongapo District Jail Male Dormitory',
        'Olongapo District Jail Female Dormitory',
      ]
    },
    {
      label: 'Provincial Jail of Aurora',
      facilities: [
        'Baler Municipal Jail',
      ]
    },

  ];